// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (min-width: 1024px) {\n.form-subscribe[data-v-027d972e] .form-subscribe-legals {\nleft: auto;\nbottom: auto;\nheight: 100vh;\nmin-height: 100%;\nwidth: calc(100 * var(--vw, 1vw));\n      margin-right: calc(-1 * var(--container-margin))\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
